export default {
  MEMBER: 'memberAvailability',
  NON_MEMBER: 'nonMemberAvailability',
  MEMBER_TOTAL: 'memberAvailabilityTotalPrice',
  NON_MEMBER_TOTAL: 'nonMemberAvailabilityTotalPrice',
};
